<template>
  <div class="history">
    <div class="mobile">
      <header>
        <div class="date">
          <button v-on:click="setMonth(false)">&lt;</button>
          <span>{{ dateFormatted }}</span>
          <button v-on:click="setMonth(true)">&gt;</button>
        </div>
        <div class="row">
          <div class="left">
            <button
                class="arrow-btn blackWhite"
                v-bind:class="{ on: allOpen }"
                v-on:click="toggleAllCompany()"
            ></button>
          </div>
          <div class="right">
            <p>Namontováno: {{ mountedCount }}</p>
          </div>
        </div>
      </header>
      <main>
        <section class="date" v-for="unit in units" v-bind:key="unit.date">
          <header>
            <div class="row">
              <div class="left">
                <p>{{ formatDate(unit.date) }}</p>
              </div>
              <div class="right">
                <p>{{ unit.companies.units }} montáží</p>
              </div>
            </div>
          </header>
          <main>
            <section
              class="company"
              v-bind:class="{ open: company.closed }"
              v-for="company in unit.companies"
              v-bind:key="company.title"
            >
              <header v-on:click="toggleCompany(company)">
                <div class="left">
                  <button
                    class="arrow-btn"
                    v-bind:class="{ on: company.closed }"
                  ></button>
                </div>
                <div class="center">
                  <div class="row">
                    <div class="left">
                      <p>{{ company.company }}</p>
                    </div>
                    <div class="right">
                      <p>GPS / CAN</p>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <p>{{ company.units.length }}</p>
                </div>
              </header>
              <main v-if="company.closed">
                <div
                  class="row"
                  v-for="unit in company.units"
                  v-bind:key="unit.originalId"
                >
                  <div class="left">
                    <button
                        class="detail-icon"
                        v-on:click="editUnit(unit)"
                        v-if="!unit.editable && getRole != 2"
                    ></button>
                    <button
                      class="edit-icon"
                      v-on:click="editUnit(unit)"
                      v-if="unit.editable && getRole != 2"
                    ></button>
                    <button
                      class="delete-icon"
                      v-on:click="deleteUnit(unit, company)"
                      v-if="unit.editable && getRole != 2"
                    ></button>
                  </div>
                  <div class="center">
                    <div class="row">
                      <div class="left">
                        <div class="row">
                          <p>{{ unit.name }} ({{ unit.plate }})</p>
                        </div>
                        <div class="row">
                          <p>
                            <strong>{{ unit.imei }}</strong>
                          </p>
                        </div>
                      </div>
                      <div class="middle">
                        <span
                          class="icon"
                          v-bind:class="{
                            success: unit.checkBasic,
                            error: !unit.checkBasic
                          }"
                        >
                          <template v-if="unit.checkBasic">
                            <CheckIcon />
                          </template>
                          <template v-else>
                            <CrossIcon />
                          </template>
                        </span>
                        <span
                          class="icon"
                          v-bind:class="{
                            success: unit.checkCan == 1,
                            error: unit.checkCan == 2
                          }"
                        >
                          <template v-if="unit.checkCan == 1">
                            <CheckIcon />
                          </template>
                          <template v-else-if="unit.checkCan == 2">
                            <CrossIcon />
                          </template>
                          <template v-else>
                            <CircleIcon />
                          </template>
                        </span>

                      </div>
                      <div class="right">
                        <button
                          class="btn"
                          v-on:click="checkUnit(unit)"
                          v-if="unit.editable && getRole != 2"
                        >
                          Znovu ověřit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </section>
          </main>
        </section>
      </main>
    </div>
    <div class="desktop">
      <header>
        <div class="date">
          <button v-on:click="setMonth(false)">&lt;</button>
          <span>{{ dateFormatted }}</span>
          <button v-on:click="setMonth(true)">&gt;</button>
        </div>
        <div class="row">
          <div class="left"></div>
          <div class="right">
            <p>Namontováno: {{ mountedCount }}</p>
          </div>
        </div>
      </header>
      <main>
        <table cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Datum a čas</th>
              <th>Firma</th>
              <th>Název vozidla</th>
              <th>SPZ</th>
              <th>Barva</th>
              <th>Typ vozidla</th>
              <th>Tachometr</th>
              <th>GPS / CAN</th>
              <th>Poznámka</th>
              <th>Namontoval</th>
              <th v-if="getRole != 2">Možnosti</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="unit in units">
              <template v-for="company in unit.companies">
                <template v-for="unit in company.units">
                  <tr v-bind:key="unit.originalId">
                    <td>{{ formatDate(unit.datetime) }}</td>
                    <td>{{ unit.client }}</td>
                    <td>{{ unit.name }}</td>
                    <td>{{ unit.plate }}</td>
                    <td>{{ getColor(unit.color) }}</td>
                    <td>{{ getType(unit.type) }}</td>
                    <td>
                      <template v-if="unit.tachometer">{{
                        unit.tachometer
                      }}</template>
                      <template v-else>---</template>
                    </td>
                    <td>
                      <span
                        class="icon"
                        v-bind:class="{
                          success: unit.checkBasic,
                          error: !unit.checkBasic
                        }"
                      >
                        <template v-if="unit.checkBasic">
                          <CheckIcon />
                        </template>
                        <template v-else>
                          <CrossIcon />
                        </template>
                      </span>
                      <span
                        class="icon"
                        v-bind:class="{
                          success: unit.checkCan == 1,
                          error: unit.checkCan == 2
                        }"
                      >
                        <template v-if="unit.checkCan == 1">
                          <CheckIcon />
                        </template>
                        <template v-else-if="unit.checkCan == 2">
                          <CrossIcon />
                        </template>
                        <template v-else>
                          <CircleIcon />
                        </template>
                      </span>
<!--                      <span-->
<!--                        class="icon"-->
<!--                        v-bind:class="{-->
<!--                          success: unit.checkTacho == 1,-->
<!--                          error: unit.checkTacho == 2-->
<!--                        }"-->
<!--                      >-->
<!--                        <template v-if="unit.checkTacho == 1">-->
<!--                          <CheckIcon />-->
<!--                        </template>-->
<!--                        <template v-else-if="unit.checkTacho == 2">-->
<!--                          <CrossIcon />-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                          <CircleIcon />-->
<!--                        </template>-->
<!--                      </span>-->
                    </td>
                    <td>
                      <template v-if="unit.note">{{ unit.note }}</template>
                      <template v-else>---</template>
                    </td>
                    <td>{{ unit.technician }}</td>
                    <td v-if="getRole != 2">
                      <button
                          class="detail-icon"
                          v-on:click="editUnit(unit)"
                          v-if="!unit.editable && getRole != 2"
                      ></button>
                      <button
                        class="edit-icon"
                        v-on:click="editUnit(unit)"
                        v-if="unit.editable"
                      ></button>
                      <button
                        class="delete-icon"
                        v-on:click="deleteUnit(unit, company)"
                        v-if="unit.editable"
                      ></button>
                      <button
                          class="btn check-btn"
                          v-on:click="checkUnit(unit)"
                          v-if="unit.editable && getRole != 2"
                      >
                        Znovu ověřit
                      </button>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </tbody>
        </table>
      </main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "../store";
import moment from "moment";
import CrossIcon from "@/icons/CrossIcon.vue";
import CheckIcon from "@/icons/CheckIcon.vue";
import CircleIcon from "@/icons/CircleIcon.vue";

export default {
  name: "History",
  mounted() {
    document.title = "GPS Dozor Servis | Historie montáží";
    //this.checkStart();
    this.loadHistory();
  },
  components: {
    CheckIcon,
    CrossIcon,
    CircleIcon
  },
  computed: {
    idUnit() {
      return store.state.idUnit;
    },
    result() {
      return store.state.checkResult;
    },
    checkContinue() {
      //if(this.client === "") return true;
      if (this.name === "") return true;
      if (this.plate === "") return true;
      if (this.type === "") return true;
      if (this.color === 0) return true;
      if (this.hasTachometer && this.tachometer === "") return true;
      return false;
    },
    getColorCode() {
      if (this.color == null) {
        return "";
      }
      return this.color.code;
    },
    getInvoiced() {
      return 19;
    },
    getTotal() {
      return 19;
    },
    getRole() {
      return store.state.role;
    },
    dateFormatted(){
      let date = this.date.locale("cs").format("MMMM YYYY");
      date = date[0].toUpperCase()+date.slice(1).toLowerCase();
      return date;
    }
  },
  data: function() {
    return {
      date: moment(),
      invoicedCount: 0,
      mountedCount: 0,
      units: null,
      allOpen: true
    };
  },
  methods: {
    setType: function(id) {
      this.type = id;
    },
    saveSubmit: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("save", {
        client: this.client,
        name: this.name,
        plate: this.plate,
        color: parseInt(this.color.id),
        type: parseInt(this.type),
        hasTachometer: this.hasTachometer,
        tachometer: parseInt(this.tachometer),
        typeMontage: parseInt(this.typeMontage),
        price: this.price,
        km: this.km,
        note: this.note
      });
      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      if (result) {
        store.commit("saveState");
        this.$router.push("finish");
      } else {
        this.info = "Chyba";
      }
    },
    checkStart: function() {
      if (store.state.checkResult === null) {
        this.$router.push("check");
        return;
      }
    },
    loadHistory: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("history", {
        date: this.date.format("YYYY-MM-DD")
      });
      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      this.invoicedCount = 0;
      this.mountedCount = 0;

      const sortResult = result.sort((a, b) => moment(b.date)-moment(a.date));

      sortResult.forEach(date => {
        const companies = date.companies;
        var unitsMounted = 0;

        companies.forEach(company => {
          const units = company.units;
          company.closed = true;
          var companyInvoiced = 0;

          units.forEach(unit => {
            if (unit.invoiced) {
              this.invoicedCount++;
              companyInvoiced++;
            }

            unitsMounted++;
            this.mountedCount++;
          });

          if (companyInvoiced === units.length) {
            company.totalInvoiced = true;
          }
        });
        companies.units = unitsMounted;
      });

      this.units = result;
    },
    setMonth: function(dir) {
      if (dir) {
        this.date = moment(this.date).add(1, "months");
      } else {
        this.date = moment(this.date).subtract(1, "months");
      }
      this.loadHistory();
    },
    formatDate: function(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    getType: function(type) {
      const types = ["Small", "Sedan", "Combi", "Van", "Bus", "Truck"];

      return types[type];
    },
    getTypeMontage: function(typeMontage) {
      const typesMontage = [
        "Standardní montáž",
        "Montáž včetně identifikace",
        "Montáž včetně CAN",
        "Demontáž",
        "Jiný (poznámka)"
      ];

      return typesMontage[typeMontage];
    },
    getColor: function(color) {
      const colors = [
        "Šedá/bílá",
        "Modrá",
        "Černá",
        "Zelená",
        "Růžová",
        "Žlutá"
      ];

      return colors[color];
    },
    toggleCompany: function(company) {
      company.closed = !company.closed;
    },
    toggleAllCompany: function() {
      this.allOpen = !this.allOpen;
      this.units.forEach(unit => {
        unit.companies.forEach(company => {
          company.closed = this.allOpen;
        });
      });
    },
    toggleInvoicedUnit: async function(unit, company) {
      unit.invoiced = !unit.invoiced;

      await store.dispatch("editUnit", {
        unit: unit
      });

      if (unit.invoiced) {
        this.invoicedCount++;
      } else {
        this.invoicedCount--;
      }

      var companyInvoiced = 0;
      company.units.forEach(unit => {
        if (unit.invoiced) {
          companyInvoiced++;
        }
      });
      if (companyInvoiced === company.units.length) {
        company.totalInvoiced = true;
      } else {
        company.totalInvoiced = false;
      }
    },

    toggleInvoicedCompany: async function(company) {
      company.totalInvoiced = !company.totalInvoiced;

      for (var i = 0; i < company.units.length; i++) {
        const unit = company.units[i];
        if (unit.invoiced == company.totalInvoiced) {
          continue;
        }
        unit.invoiced = company.totalInvoiced;
        if (unit.invoiced) {
          this.invoicedCount++;
        } else {
          this.invoicedCount--;
        }
        await store.dispatch("editUnit", {
          unit: unit
        });
      }
    },
    editUnit: async function(unit) {
      const result = await store.dispatch("getUnit", {
        unit: unit
      });
      if (!result.editable) {
        unit.editable = false;
      }
      this.$router.push({ name: "Save", params: { unit: unit } });
    },
    checkUnit: async function(unit) {
      const result = await store.dispatch("getUnit", {
        unit: unit
      });
      if (result.editable) {
        this.$router.push({ name: "Check", params: { unit: unit } });
      } else {
        alert("Tuto jednotku již nejde ověřit");
        unit.editable = false;
      }
    },
    deleteUnit: async function(unit, company) {
      const result = await store.dispatch("getUnit", {
        unit: unit
      });
      if (result.editable) {
        if (confirm("Opravdu chcete smazat tuto jednotku?")) {
          store.commit("showLoading");
          await store.dispatch("deleteUnit", {
            unit: unit
          });
          store.commit("hideLoading");

          const units = company.units;
          let newUnits = [];
          units.forEach(unitTemp => {
            if (unitTemp.originalId != unit.originalId) {
              newUnits.push(unitTemp);
            }
          });
          company.units = newUnits;
          this.invoicedCount--;
          this.mountedCount--;
        }
      } else {
        alert("Tuto jednotku již nejde smazat.");
        unit.editable = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/1-base/variables";
@import "~vue-select/dist/vue-select.css";

.history {
  .mobile {
    display: none;

    & > header {
      .date {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;

        span {
          white-space: nowrap;
          margin: 0 10px;
          font-weight: 700;
        }

        button {
          width: 40px;
        }
      }
      .row {
        justify-content: space-between;
        background-color: black;
        padding: 4px 8px;
        color: #fff;
      }
    }

    .row {
      display: flex;
    }

    .date {
      & > header {
        background-color: @grey;
        padding: 4px 8px;
        .row {
          justify-content: space-between;
        }
      }

      & > main {
      }
    }

    .company {
      header {
        display: flex;
        justify-content: space-between;
        padding: 10px 8px;
        align-items: center;
        cursor: pointer;
        .center {
          width: 100%;
          margin-left: 10px;

          .row {
            justify-content: space-between;

            .right {
              margin-right: 12px;
              p {
                font-size: 12px;
                white-space: nowrap;
              }
            }
          }
        }
        .right {
          min-width: 80px;
          width: 80px;
          display: flex;
          justify-content: flex-end;

          p {
            margin: 0;
          }

          align-items: center;
          .checkbox {
            margin-left: 4px;
          }
        }
      }
      main {
        padding-bottom: 10px;

        & > .row {
          margin-top: 6px;
          border-top: 1px solid @grey-10;
          padding: 10px 8px 0;

          &:first-child {
            margin-top: 0;
          }
        }

        .row {
          justify-content: space-between;
        }

        .left {
          display: flex;
          min-width: 42px;

          button {
            padding: 0;

            margin-left: 2px;
            &:first-child {
              margin-left: 0;
            }
          }
        }
        .center {
          margin-left: 10px;
          width: 100%;
          text-align: left;
          .row {
            margin-top: 4px;
            justify-content: space-between;
            p {
              font-size: 12px;
              margin: 0;
            }

            &:first-child {
              margin-top: 0;
              p {
                font-size: 14px;
              }
            }
          }
          .left {
            flex-wrap: wrap;
            width: 100%;
            @media (max-width: 374px) {
              width: 110px;
            }

            .row {
              width: 100%;
            }
          }
          .middle {
            min-width: 88px;
            text-align: center;
            padding-right: 6px;
            padding-left: 6px;

            span {
              margin-left: 2px;
              &:first-child {
                margin-left: 0;
              }
            }
          }
          .info {
            padding-right: 24px;
          }
        }
        .right {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          width: 80px;
          min-width: 80px;
          justify-content: flex-end;

          .btn {
            width: 100%;
            font-size: 14px;
            margin-bottom: 10px;
            padding: 4px;

            //padding: 0;
          }

          small {
            font-size: 12px;
          }

          .checkbox {
            margin-left: 4px;
          }
        }
      }

      &.open {
        header {
          .center {
            p {
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .desktop {
    .row {
      display: flex;
    }
    & > header {
      .date {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;

        span {
          white-space: nowrap;
          margin: 0 10px;
          font-weight: 700;
        }

        button {
          width: 40px;
        }
      }
      .row {
        justify-content: space-between;
        background-color: black;
        padding: 4px 8px;
        color: #fff;
      }
    }
    & > main {
      overflow: auto;

      table {
        font-size: 12px;
        width: 100%;

        th {
          white-space: nowrap;
          padding: 4px;
          background-color: @grey;
          text-align: left;
          &:first-child {
            padding-left: 8px;
          }
          &:last-child {
            padding-left: 8px;
          }
        }
        td {
          white-space: nowrap;
          padding: 4px;
          &:first-child {
            padding-left: 8px;
          }
          &:last-child {
            padding-left: 8px;
          }
        }
      }
    }
    .check-btn{
      position: relative;
      top: 3px;
      width: auto;
      font-size: 12px;
      padding: 4px;
      margin-bottom: 0;
      border-radius: 4px;
      margin-left: 4px;
    }
  }

  .icon {
    color: @black;
    svg {
      width: 24px;
    }
    &.success {
      color: @green;
    }
    &.error {
      color: @red;
    }
  }

  @media (max-width: 479px) {
    .mobile {
      display: block;
    }
    .desktop {
      display: none;
    }
  }
}
</style>

<style>
.vs__clear {
  width: auto;
  color: #524b47;
}

.vs__clear:hover {
  color: #524b47;
  background-color: transparent;
}

.vs__dropdown-toggle {
  border: 0;
}

.vs__search {
  width: 0 !important;
}
</style>
